(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Breakpoints.

     WD_DESKTOP_MIN is the width at which the header hamburger disappears
     (see sections/header.liquid). Below it the collection filters use the
     mobile drawer, so none of the desktop sidebar behaviour applies.

     WD_TIERS lists which Ansicht (column) choices each viewport offers,
     widest first. It must stay in sync with the media queries in
     wd-facets.css and with the buttons in snippets/wd-view-switcher.liquid.
     ------------------------------------------------------------------ */
  var WD_DESKTOP_MIN = 1070;

  var WD_TIERS = [
    { min: 2560, cols: [3, 4, 5, 6] },
    { min: 1920, cols: [3, 4, 5] },
    { min: 0, cols: [3] } // 1070–1919px and every narrower viewport: fixed
  ];

  function viewportWidth() {
    return window.innerWidth || document.documentElement.clientWidth || 0;
  }

  function allowedCols() {
    var w = viewportWidth();
    for (var i = 0; i < WD_TIERS.length; i++) {
      if (w >= WD_TIERS[i].min) return WD_TIERS[i].cols;
    }
    return WD_TIERS[WD_TIERS.length - 1].cols;
  }

  /* ------------------------------------------------------------------
     Sidebar = one product card (one grid cell).
     The filter panel overlays the grid. Its height, width AND position are
     measured from the FIRST product card, so the panel always matches that
     card exactly — at every viewport and every Ansicht column count.
     Filters that are taller than the card scroll inside the panel.

     When the card is narrow, `wd-panel-narrow` is set on .facets-vertical
     and wd-facets.css switches the panel content to compact spacing so
     nothing overflows.
     ------------------------------------------------------------------ */
  // Below this card width the panel content needs the compact spacing.
  // ~435px fits a full 8-dot swatch row at the regular 35px gaps + paddings.
  var WD_PANEL_COMPACT_MAX = 436;

  function syncSidebarHeight() {
    var panel = document.getElementById('main-collection-filters');
    var grid = document.getElementById('product-grid');
    if (!panel || !grid) return;

    var layout = panel.closest('.facets-vertical');

    function clearSizing() {
      panel.style.height = '';
      panel.style.width = '';
      panel.style.left = '';
      if (layout) layout.classList.remove('wd-panel-narrow');
    }

    // Desktop only — below WD_DESKTOP_MIN the drawer is used, not the overlay.
    if (viewportWidth() < WD_DESKTOP_MIN) {
      clearSizing();
      return;
    }

    var item = grid.querySelector('.grid__item');
    if (!item) {
      clearSizing();
      return;
    }

    var rect = item.getBoundingClientRect();
    if (!(rect.width > 0)) {
      clearSizing();
      return;
    }

    panel.style.height = rect.height > 0 ? Math.round(rect.height) + 'px' : '';

    // Width + horizontal position: exactly the first card.
    panel.style.width = Math.round(rect.width) + 'px';
    var host = panel.offsetParent;
    if (host) {
      panel.style.left = Math.round(rect.left - host.getBoundingClientRect().left) + 'px';
    }

    if (layout) {
      layout.classList.toggle('wd-panel-narrow', rect.width < WD_PANEL_COMPACT_MAX);
    }
  }

  function scheduleSyncSidebarHeight() {
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(syncSidebarHeight);
    } else {
      syncSidebarHeight();
    }
  }

  /* ------------------------------------------------------------------
     Filter panel (FILTERN) — open/close the sidebar overlay
     ------------------------------------------------------------------ */
  function initFilterPanel() {
    var toggle = document.getElementById('WdFilterToggle');
    var panel = document.getElementById('main-collection-filters');
    if (!toggle || !panel) return;

    var layout = panel.closest('.facets-vertical');

    function isOpen() {
      return panel.classList.contains('is-open');
    }

    function open() {
      panel.classList.add('is-open');
      if (layout) layout.classList.add('wd-filters-open');
      toggle.classList.add('is-active');
      toggle.setAttribute('aria-expanded', 'true');
      scheduleSyncSidebarHeight();
    }

    function close() {
      panel.classList.remove('is-open');
      if (layout) layout.classList.remove('wd-filters-open');
      toggle.classList.remove('is-active');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function (event) {
      event.stopPropagation();
      if (isOpen()) {
        close();
      } else {
        open();
      }
    });

    panel.addEventListener('click', function (event) {
      event.stopPropagation();
    });

    document.addEventListener('click', function (event) {
      if (isOpen() && !panel.contains(event.target) && !toggle.contains(event.target)) {
        close();
      }
    });

    document.addEventListener('keyup', function (event) {
      if ((event.key === 'Escape' || event.key === 'Esc') && isOpen()) {
        close();
        toggle.focus();
      }
    });

    var countEl = toggle.querySelector('.wd-filter-toggle__count');

    function syncCount() {
      if (!countEl) return;
      var source = panel.querySelector('.wd-filter-count');
      var number = source ? source.textContent.replace(/[^0-9]/g, '') : '';
      if (number) {
        countEl.textContent = '| ' + number;
        countEl.hidden = false;
      } else {
        countEl.textContent = '';
        countEl.hidden = true;
      }
    }

    syncCount();

    if ('MutationObserver' in window) {
      new MutationObserver(syncCount).observe(panel, { childList: true, subtree: true });
    }
  }

  /* ------------------------------------------------------------------
     Sort bar (SORTIEREN) — clicking the label toggles the options open/closed
     ------------------------------------------------------------------ */
  function initSortBar() {
    var options = document.getElementById('WdSortOptions');
    var toggle = document.getElementById('WdSortToggle');
    if (!options || !toggle) return;

    function isOpen() {
      return options.classList.contains('is-open');
    }
    function open() {
      options.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
    function close() {
      options.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    // Start collapsed.
    close();

    toggle.addEventListener('click', function (event) {
      event.stopPropagation();
      if (isOpen()) {
        close();
      } else {
        open();
      }
    });

    // The sort bar is not re-rendered when the grid reloads, so keep the
    // active option highlighted after a sort changes.
    options.addEventListener('change', function (event) {
      if (!event.target || event.target.name !== 'sort_by') return;
      var opts = options.querySelectorAll('.wd-sortbar__opt');
      for (var i = 0; i < opts.length; i++) {
        var input = opts[i].querySelector('input');
        opts[i].classList.toggle('is-active', !!(input && input.checked));
      }
    });

    document.addEventListener('click', function (event) {
      if (isOpen() && !options.contains(event.target) && !toggle.contains(event.target)) {
        close();
      }
    });

    document.addEventListener('keyup', function (event) {
      if ((event.key === 'Escape' || event.key === 'Esc') && isOpen()) {
        close();
        toggle.focus();
      }
    });
  }

  /* ------------------------------------------------------------------
     Single-select filters (opt-in via data-wd-single). Kept for any filter
     the merchant lists in the "Single-select filters" section setting.
     ------------------------------------------------------------------ */
  function initSingleSelect() {
    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || input.type !== 'checkbox' || !input.checked) return;

      var list = input.closest('[data-wd-single="true"]');
      if (!list) return;

      var others = list.querySelectorAll('input[type="checkbox"]');
      for (var i = 0; i < others.length; i++) {
        // Setting .checked does not re-fire change, so this cannot loop.
        if (others[i] !== input && others[i].checked) others[i].checked = false;
      }
    });
  }

  /* ------------------------------------------------------------------
     Ansicht (view) + Model (image swap) — custom client-side controls.

     Neither is a product filter: Ansicht changes how many grid columns show,
     Model swaps every card's image to the one whose ALT matches the model.
     State is kept in memory and re-applied whenever facets.js replaces the
     product grid (color/size filters, pagination, sorting).
     ------------------------------------------------------------------ */
  var GRID_COL_CLASSES = [
    'grid--1-col-desktop',
    'grid--2-col-desktop',
    'grid--3-col-desktop',
    'grid--4-col-desktop',
    'grid--5-col-desktop',
    'grid--6-col-desktop'
  ];

  var layoutEl = null;
  // The shopper's preferred column count (3–6). It is kept even when the
  // current viewport can't offer it, so widening the window restores it.
  var prefCols = null;
  var appliedCols = null;
  var currentModel = null; // 'ghost' | 'mensch' | 'produkt' | null

  // Preference clamped to what this viewport offers: exact match if possible,
  // otherwise the closest available count (e.g. 6 -> 5 below 2560px).
  function resolvedCols() {
    var allowed = allowedCols();
    var pref = prefCols || allowed[0];
    if (allowed.indexOf(pref) !== -1) return pref;

    var best = allowed[0];
    for (var i = 1; i < allowed.length; i++) {
      if (Math.abs(allowed[i] - pref) < Math.abs(best - pref)) best = allowed[i];
    }
    return best;
  }

  function setActive(selector, activeBtn) {
    var btns = document.querySelectorAll(selector);
    for (var i = 0; i < btns.length; i++) {
      var on = btns[i] === activeBtn;
      btns[i].classList.toggle('is-active', on);
      btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  function syncAnsichtButtons(cols) {
    var btns = document.querySelectorAll('.wd-ansicht-btn');
    for (var i = 0; i < btns.length; i++) {
      var on = parseInt(btns[i].getAttribute('data-cols'), 10) === cols;
      btns[i].classList.toggle('is-active', on);
      btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  function applyView() {
    var cols = resolvedCols();
    appliedCols = cols;

    var grid = document.getElementById('product-grid');
    if (grid) {
      for (var i = 0; i < GRID_COL_CLASSES.length; i++) grid.classList.remove(GRID_COL_CLASSES[i]);
      grid.classList.add('grid--' + cols + '-col-desktop');
    }
    if (layoutEl) layoutEl.setAttribute('data-wd-cols', String(cols));

    syncAnsichtButtons(cols);
    // Card size changed with the column count → re-clamp the sidebar height.
    scheduleSyncSidebarHeight();
  }

  function applyModel(root) {
    var scope = root || document.getElementById('product-grid');
    if (!scope) return;
    var imgs = scope.querySelectorAll('.wd-cs-img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var def = img.getAttribute('data-wd-img-default');
      var url = currentModel ? img.getAttribute('data-wd-img-' + currentModel) : null;

      if (currentModel && url) {
        if (!img.dataset.wdOrigSrcset && img.getAttribute('srcset')) {
          img.dataset.wdOrigSrcset = img.getAttribute('srcset');
        }
        img.removeAttribute('srcset');
        if (img.getAttribute('src') !== url) img.setAttribute('src', url);
      } else {
        if (def && img.getAttribute('src') !== def) img.setAttribute('src', def);
        if (img.dataset.wdOrigSrcset) img.setAttribute('srcset', img.dataset.wdOrigSrcset);
      }
    }
  }

  function initViewAndModel() {
    layoutEl = document.querySelector('.facets-vertical');
    if (layoutEl) {
      var c = parseInt(layoutEl.getAttribute('data-wd-default-cols'), 10) ||
        parseInt(layoutEl.getAttribute('data-wd-cols'), 10);
      if (c) prefCols = c;
    }

    // Reflect the server-rendered active Ansicht button in memory.
    var activeAnsicht = document.querySelector('.wd-ansicht-btn.is-active');
    if (activeAnsicht) {
      var ac = parseInt(activeAnsicht.getAttribute('data-cols'), 10);
      if (ac) prefCols = ac;
    }

    // Capture phase: the filter panel stops click propagation to keep itself
    // open, so a normal (bubbling) document listener would never see clicks on
    // the controls inside it. Capturing fires before that stopPropagation.
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var vbtn = target.closest('.wd-ansicht-btn');
      if (vbtn) {
        event.preventDefault();
        var cols = parseInt(vbtn.getAttribute('data-cols'), 10);
        if (!cols || allowedCols().indexOf(cols) === -1) return;
        prefCols = cols;
        applyView();
        return;
      }

      var mbtn = target.closest('.wd-model-btn');
      if (mbtn) {
        event.preventDefault();
        var model = mbtn.getAttribute('data-model');
        if (currentModel === model) {
          currentModel = null;
          setActive('.wd-model-btn', null);
        } else {
          currentModel = model;
          setActive('.wd-model-btn', mbtn);
        }
        applyModel();
        return;
      }
    }, true);

    // Re-apply Ansicht + Model every time the product grid is rebuilt by AJAX.
    var gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer && 'MutationObserver' in window) {
      new MutationObserver(function () {
        applyView();
        applyModel();
        scheduleSyncSidebarHeight();
      }).observe(gridContainer, { childList: true, subtree: true });
    }

    // facets.js also re-renders the filter panel, which rebuilds the Ansicht
    // buttons with the section default marked active — restore the shopper's
    // choice. childList only: the class/aria writes below are attribute
    // changes, so this observer can't retrigger itself.
    var filterPanel = document.getElementById('main-collection-filters');
    if (filterPanel && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (appliedCols) syncAnsichtButtons(appliedCols);
      }).observe(filterPanel, { childList: true, subtree: true });
    }

    // Crossing a tier boundary changes which column counts are on offer, so
    // re-resolve the view (and re-clamp the sidebar) whenever the width moves.
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (resolvedCols() !== appliedCols) {
          applyView();
        } else {
          syncSidebarHeight();
        }
      }, 150);
    });

    applyView();
    applyModel();
    scheduleSyncSidebarHeight();
  }

  // Isolate each module so a failure in one never prevents the others from
  // running (in particular, the Ansicht/Model click delegation must always be
  // attached even if the panel or sort-bar setup throws).
  function safe(fn, label) {
    try {
      fn();
    } catch (e) {
      if (window.console && window.console.error) window.console.error('[wd-controls] ' + label + ' failed:', e);
    }
  }

  function init() {
    if (window.__wdControlsInit) return;
    window.__wdControlsInit = true;
    safe(initFilterPanel, 'filter-panel');
    safe(initSortBar, 'sort-bar');
    safe(initSingleSelect, 'single-select');
    safe(initViewAndModel, 'view-model');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Safety nets — the guard above makes init run at most once regardless of how
  // the script is loaded (deferred, injected, or re-run by a section reload).
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();
